import React, { Fragment } from "react";
import { Field } from "redux-form";

import { presence, presenceMultiSelect } from "../../../shared/validations";
import RenderMultiSelectField from "../../../lib/components/RenderMultiSelectField";
import Select from "../../../lib/components/Select";
import MultiSelect from "lib/components/MultiSelectReduxForm";
import { stylesSelect } from "shared/ui/material-ui-styles/use-style-imputs";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";

class CustomSelect extends React.Component {
  formatOptions(options, isMultiple) {
    if (isMultiple) {
      return options.toJS().map((option) => {
        return { label: option.name, value: option.name };
      });
    } else {
      let optionComponents = options.map((option, idx) => {
        return (
          <option key={idx} value={option.get("name")}>
            {option.get("name")}
          </option>
        );
      });
      return optionComponents.insert(
        0,
        <option key={"default"} disabled={true} value={""}>
          ----
        </option>,
      );
    }
  }

  formattedOptions(options, label) {
    const opts = options.toJSON();

    return (
      <Fragment>
        <option key={"default"} disabled={true} value={""}>
          {label}
        </option>
        {opts.map(({ name, id }) => (
          <option key={id} value={name}>
            {name}
          </option>
        ))}
      </Fragment>
    );
  }

  formatEmbeddedOptionsSingleSelect(options, isMultiple) {
    if (isMultiple) {
      return options.toJS().map((option) => {
        return { label: option, value: option };
      });
    } else {
      let optionComponents = options.map((option, idx) => {
        return (
          <option key={idx} value={option}>
            {option.get("name")}
          </option>
        );
      });
      return optionComponents.insert(
        0,
        <option key={"default"} disabled={true} value={""}>
          ----
        </option>,
      );
    }
  }

  renderField({ customField, isMultiple, isRequired, isEmbedded, classes }) {
    if (!isEmbedded) {
      if (isMultiple) {
        return (
          <Field
            aria-label={customField.get("label")}
            name={`custom_fields_hash.${customField.get("name")}`}
            component={MultiSelect}
            options={this.formatOptions(
              customField.get("entity_custom_values"),
              isMultiple,
            )}
            validate={isRequired ? [presenceMultiSelect] : null}
          />
        );
      } else {
        return (
          <Field
            aria-label={customField.get("label")}
            className="p-sm-b"
            name={`custom_fields_hash.${customField.get("name")}`}
            component={Select}
            children={this.formatOptions(
              customField.get("entity_custom_values"),
              isMultiple,
            )}
            validate={isRequired ? [presence] : null}
          />
        );
      }
    } else {
      if (isMultiple) {
        return (
          <Field
            name={`custom_fields_hash.${customField.get("name")}`}
            component={RenderMultiSelectField}
            formControlClass="full-width-mobile"
            hasChips={true}
            inputLabelText={
              isRequired ? `*${customField.get("label")}` : customField.get("label")
            }
            classes={classes}
            children={this.formatOptions(
              customField.get("entity_custom_values"),
              isMultiple,
            )}
            validate={isRequired ? [presenceMultiSelect] : null}
          />
        );
      } else {
        return (
          <Field
            className="custom-fields"
            name={`custom_fields_hash.${customField.get("name")}`}
            component={Select}
            formControlClass="full-width-mobile"
            inputLabelText={
              isRequired ? `*${customField.get("label")}` : customField.get("label")
            }
            classes={classes}
            children={this.formattedOptions(
              customField.get("entity_custom_values"),
              customField.get("label"),
            )}
            validate={isRequired ? [presenceMultiSelect] : null}
          />
        );
      }
    }
  }

  render() {
    const { wrapperClassName, customField, isEmbedded, classes } = this.props;
    const isRequired = customField.get("required") === true;
    const isMultiple = customField.get("multiple") === true;
    const className = isRequired ? "required-field" : null;

    return (
      <React.Fragment>
        {isEmbedded && (
          <div className={`${wrapperClassName}`}>
            {this.renderField({
              customField,
              isMultiple,
              isRequired,
              isEmbedded,
              classes,
            })}
          </div>
        )}
        {!isEmbedded && (
          <div className={`${wrapperClassName} p-sm-b`}>
            <label className={className} htmlFor={customField.get("name")}>
              {customField.get("label")}
            </label>
            {this.renderField({ customField, isMultiple, isRequired })}
          </div>
        )}
      </React.Fragment>
    );
  }
}

CustomSelect.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(stylesSelect)(CustomSelect);
